const MODULE_NAME = 'UsersModule';

export const SET_CURRENT_USER = `${MODULE_NAME}/SET_CURRENT_USER`;
export const LOCAL_SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_USERS = `${MODULE_NAME}/SET_USERS`;
export const LOCAL_SET_USERS = 'SET_USERS';
export const SET_USERS_PENDING_APPROVAL = `${MODULE_NAME}/SET_USERS_PENDING_APPROVAL`;
export const LOCAL_SET_USERS_PENDING_APPROVAL = 'SET_USERS_PENDING_APPROVAL';
export const SET_USERS_LOGGED_IN_TODAY = `${MODULE_NAME}/SET_USERS_LOGGED_IN_TODAY`;
export const LOCAL_SET_USERS_LOGGED_IN_TODAY = 'SET_USERS_LOGGED_IN_TODAY';
export const SET_USERS_REJECTED = `${MODULE_NAME}/SET_USERS_REJECTED`;
export const LOCAL_SET_USERS_REJECTED = 'SET_USERS_REJECTED';
export const SET_USERS_WITHOUT_SEPIA_INFO = `${MODULE_NAME}/SET_USERS_WITHOUT_SEPIA_INFO`;
export const LOCAL_SET_USERS_WITHOUT_SEPIA_INFO =
  'SET_USERS_WITHOUT_SEPIA_INFO';
